function jsonp(url, params = {}, timeout = 5000) {
    if (typeof document === 'undefined') {
        return Promise.reject({ status: 400, statusText: 'JSONP requires browser environment' });
    }

    const callbackName = `jsonp_${Math.floor(Math.random() * 1e5)}_${Date.now()}`;
    const query = new URLSearchParams({
        ...params,
        callback: callbackName,
    });

    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        let timer = null;

        const cleanup = () => {
            if (timer) {
                clearTimeout(timer);
            }
            script.onerror = null;
            script.remove();
            delete window[callbackName];
        };

        window[callbackName] = (payload) => {
            cleanup();
            resolve(payload);
        };

        script.onerror = () => {
            cleanup();
            reject({ status: 400, statusText: 'Bad Request' });
        };

        if (timeout > -1) {
            timer = setTimeout(() => {
                cleanup();
                reject({ status: 408, statusText: 'Request Timeout' });
            }, timeout);
        }

        script.src = `${url}${url.includes('?') ? '&' : '?'}${query.toString()}`;
        document.body.appendChild(script);
    });
}

// get auth
const tokenUrl = {
    xd: '//www.xd.com/api/xd_video/get_xdvideo',
};
function get_auth_token() {
    return jsonp(tokenUrl.xd)
        .then(function (res) {
            if (res.code === 0) {
                return res.data;
            } else {
                throw -1;
            }
        })
        .catch(function (error) {
            let msg = 'video auth error';
            if (!error.response && error !== -1) {
                msg = 'network error';
            }
            throw msg;
        });
}

export { get_auth_token };
